<div id="snackbar" #snackbar class="hmf-px-m hmf-py-s hmf-elevated-shadow hmf-display-flex hmf-justify-content-between hmf-align-items-center"
        [ngClass]="{'show': this.snackbarInfo.showSnackbar, 'top-80': hasBannerElement}" (mouseenter)="clearTimer()" (mouseleave)="startTimer()">
    <p class="hmf-m-0 hmf-header-bold-xs hmf-header-bold-m-s">
        <ng-container *ngIf="!snackbarInfo.isAuthSnackbar; else auth">
            <span>{{ snackbarInfo.text }}</span>
        </ng-container>
        <ng-template #auth>
            Please <span authUtilsAuthLink [redirectBackToUri]="true" class="authLink" analyticsEventToFireOnClick="multiUseAnalyticsEvent" [analyticsEventDataToFireOnClick]="analyticsEventData">
            </span> to Add to Favorites.
        </ng-template>
    </p>
    <ng-container *ngIf="snackbarInfo.link; else closeSnackbar">
        <a [href]="snackbarInfo.link" *ngIf="snackbarInfo.link">View</a>
    </ng-container>
    <ng-template #closeSnackbar>
            <homefield-icon class="icon" name="sign-cancel" (click)="exitSnackbar()"></homefield-icon>
    </ng-template>
</div>
